module.exports = __webpack_public_path__ + "assets/04f535aa293c48d564836abadc409b92.png";